/**
 * Etapas da configuração inicial (v2), na ordem da tela.
 *
 * Lista única usada pelo wizard e pelo card "Configuração inicial" do Admin Geral.
 * - key:   chave da API (track_step.php e SetupProgress::STEPS no backend)
 * - label: rótulo exibido
 *
 * Para tirar, acrescentar ou reordenar uma etapa: editar aqui, em SetupProgress::STEPS
 * e em OnboardingVariables::SETUP_STEP_LABELS (sem migration: a coluna `step` de
 * company_setup_steps é texto livre).
 *
 * Desde 2026-10-18 são três: 'schedule' e 'services' saíram (a área aplica os padrões,
 * SetupAreaDefaults.php). Linhas antigas com essas chaves ficam na tabela e não contam.
 */
export const SETUP_STEPS = [
  { key: 'area', label: 'Área de atuação' },
  { key: 'identity', label: 'Você e a clínica' },
  { key: 'demo', label: 'Teste no WhatsApp' },
];

/** Rótulo da etapa pela chave da API; devolve a própria chave se não existir. */
export function setupStepLabel(key) {
  const step = SETUP_STEPS.find((item) => item.key === key);
  return step ? step.label : key;
}
